/**
 * @file onelink延迟深链
 * @refs https://base.xiaojukeji.com/docs/advlibs
 */
import { getStore } from '@/store/store-standard'
import { Tracker } from '@/utils/event-lib'
import { isMgm } from '@/utils/dom'
import { APP_ACTION_TYPE } from '@/types'
import Channel from '@/utils/channel-lib'
export const generateOneLinkURL = () => {
  const user = getStore('user')
  const oneLink = window.adv.getDeeplinkURLByBID(
    'FINTECH_APP',
    {
      uid: user?.uid || '-1',
    }
  )
  console.log('[One Link]', oneLink)
  return oneLink
}

/**
 * MGM打开APP实验逻辑
 */
const openApp_MGM = () => {
  try {
    const data = getStore('mgm')
    if (!data) {
      throw new Error('mgm data not found')
    }
    if (data.material.extra_info.hit_experiment) {
      window.adv.executeOpenApp({
        pid: 'fintech_mgm',
      })
    } else {
      throw new Error('experiment not hit')
    }
  } catch (e: any) {
    Tracker.trackWithRaven('FN:openApp_MGM', {
      e: e.toString(),
    })
    fallback()
  }
}

const fallback = () => {
  const oneLink = generateOneLinkURL()
  Channel.positive(
    () =>
      Channel.dispatch('preload_page_open_link', {
        link: oneLink,
      }),
    () => (window.location.href = oneLink)
  )
}

/**
 * 常规流程实验
 */
const openApp_Normal = (action_type: APP_ACTION_TYPE) => {
  if (action_type === APP_ACTION_TYPE.PRESTAMOS) {
    return fallback()
  }
  try {
    if (
      action_type === APP_ACTION_TYPE.PRESTAMOS_TO_PASSENGER
    ) {
      return window.adv.executeOpenAppV2()
    }
    if (
      action_type === APP_ACTION_TYPE.PASSENGER_TO_PRESTAMOS
    ) {
      return window.adv.executeOpenApp({})
    }
    if (action_type === APP_ACTION_TYPE.WHATSAPP) {
      return (location.href =
        'https://page.didiglobal.com/driver-page/mid-page/?type=user&app=global&page=h5&lang=es-MX&country=global&url=https%3A%2F%2Fmanhattan-app.didiglobal.com%2Ffreya%2F%3Fchannel_id%3DEMA%26campaign_id%3D0001%26activity_id%3D0001%26ext%3D%257B%2522pub_fin_channel%2522%253A%25221008%2522%257D')
    }
  } catch (e: any) {
    Tracker.trackWithRaven('FN:openApp_Normal', {
      e: e.toString(),
    })
    fallback()
  }
}

/**
 * 打开app
 * @param action_type，默认值为独立端链路
 */
export const openOneLink = (
  action_type = APP_ACTION_TYPE.PRESTAMOS
) => {
  // 如果当前是mgm，走mgm的实验逻辑
  if (isMgm()) {
    return openApp_MGM()
  }
  // 如果当前不是mgm，走业务的实验逻辑，业务的实验命中情况需要上游提供
  openApp_Normal(action_type)
}
